import { render, staticRenderFns } from "./box_layout.vue?vue&type=template&id=d072a99e&scoped=true&lang=pug&"
import script from "./box_layout.vue?vue&type=script&lang=js&"
export * from "./box_layout.vue?vue&type=script&lang=js&"
import style0 from "./box_layout.vue?vue&type=style&index=0&id=d072a99e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d072a99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d072a99e', component.options)
    } else {
      api.reload('d072a99e', component.options)
    }
    module.hot.accept("./box_layout.vue?vue&type=template&id=d072a99e&scoped=true&lang=pug&", function () {
      api.rerender('d072a99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/box_layout/box_layout.vue"
export default component.exports